import { LoadPreviewInstantsCompanyState } from "../../configuration/state";
import {
    LOAD_PREVIEW_INSTANTS_COMPANY, LOAD_PREVIEW_INSTANTS_COMPANY_FAILED, LOAD_PREVIEW_INSTANTS_COMPANY_SUCCEEDED,
    LoadPreviewInstantsCompanyActionsTypes
} from "./loadPreviewInstantsCompany.types";


const initialState: LoadPreviewInstantsCompanyState = {
    instants : null,
    isLoading: false,
    error    : undefined
}

export const loadPreviewInstantsCompanyReducer = (state = initialState, action: LoadPreviewInstantsCompanyActionsTypes): LoadPreviewInstantsCompanyState => {
    switch (action.type) {
        case LOAD_PREVIEW_INSTANTS_COMPANY:
            return {
                instants : null,
                isLoading: true,
                error    : undefined
            }
        case LOAD_PREVIEW_INSTANTS_COMPANY_SUCCEEDED:
            return {
                instants : action.payload,
                isLoading: false,
                error    : undefined
            }
        case LOAD_PREVIEW_INSTANTS_COMPANY_FAILED:
            return {
                instants : null,
                isLoading: false,
                error    : action.payload
            }
        default:
            return state
    }
}